<script>
import { ElMessage, ElMessageBox, ElNotification } from "element-plus";

export default {
  name: "SchoolTemplate",
  data() {
    return {
      loading: false,
      dataList: [],
      totalElements: 0,
      totalPages: null,
      size: 15,
      file: [],
      page: 1,
      baseUrl: process.env.VUE_APP_BASE_API_URL + "api/v2/info/file/",
      board: null,
      boards: []
    };
  },
  computed: {
    currentPage() {
      return this.$route.query.page ? parseInt(this.$route.query.page, 10) : 1;
    },
  },
  watch: {
    board(newVal) {
      if (newVal) {
        this.page = 1;
        this.$router
          .replace({
            query: { ...this.$route.query, board: newVal, page: 1 },
          })
          .then(() => {
            this.getSchoolTemplates();
          })
          .catch(() => {});
      }
    }
  },
  methods: {
    getBoardList() {
      this.$http
        .get("api/v1/my-school/boards", {
          params: {
            cache: 'off',
            limit: 15,
            offset: 0
          }
        })
        .then(({ data }) => {
          this.boards = data.boards;
        })
        .catch(() => {});
    },
    beforeUploadFile(rawFile) {
      console.log(rawFile.type);
      if (!rawFile) {
        return false;
      }
      const allowedTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
        "application/vnd.ms-excel", // .xls
      ];
      if (!allowedTypes.includes(rawFile.type)) {
        ElMessage.error(`Iltimos Excel fayl yuklang! (.xlsx yoki .xls)`);
        return false;
      }
      return true;
    },
    handleSizeChange(val) {
      this.page = 1;
      this.$router
        .replace({
          query: { ...this.$route.query, size: val },
        })
        .then(() => {
          this.getSchoolTemplates();
        })
        .catch(() => {});
    },
    handleCurrentChange(val) {
      this.$router
        .replace({
          query: { ...this.$route.query, page: val },
        })
        .then(() => {
          this.getSchoolTemplates();
        })
        .catch(() => {});
    },
    getSchoolTemplates() {
      this.loading = true;
      this.page = this.$route.query.page ? this.$route.query.page : 1;
      this.size = this.$route.query.size
        ? parseInt(this.$route.query.size || "")
        : this.size;

      this.$http
        .get(`api/v1/my-school/initiative-templates`, {
          params: {
            limit: this.size,
            offset: (this.page - 1) * this.size,
            board_id: this.board
          },
        })
        .then(({ data }) => {
          this.dataList = data.templates;
          this.totalElements = data.count;
        })
        .catch((error) => {
          ElNotification.error({
            message:
              error.response.data.message ||
              "Amaliyotni bajarishda xatolik sodir bo'ldi. iltimos qayta urinib ko'ring!",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onClickDelete(id) {
      ElMessageBox.confirm("Ma'lumoitni o'chirasizmi?", "Diqqat!", {
        confirmButtonText: "Ha",
        cancelButtonText: "Bekor qilish",
        type: "warning",
      })
        .then(() => {
          this.loading = true;
          this.$http
            .delete(`/api/v1/my-school/initiative-templates/${id}`)
            .then(() => {
              ElMessage({
                type: "success",
                message: "Muvaffaqqiyatli o'chirildi",
              });
              this.getSchoolTemplates();
            })
            .catch(() => {
              ElNotification({
                type: "error",
                title: "Xatolik",
                message: "Iltimos, qayta urinib ko'ring",
              });
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          ElMessage({
            type: "info",
            message: "O'chirish bekor qilindi",
          });
        });
    },
    indexMethod(index) {
      return index + (this.page - 1) * this.size + 1;
    },
    downloadFile() {
      this.loading = true;
      this.$http
        .get(`api/v1/my-school/initiative-templates/excel`, {
          responseType: "blob",
        })
        .then((res) => {
          const url = URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
            })
          );
          const header = res.headers.get("Content-Disposition");
          const parts = header.split(";");
          let fileName = parts[1].split("=")[1];
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch(({ response }) => {
          ElNotification({
            title: "Ogohlantirish",
            message:
              response.data.message ||
              "Ma'lumot yuklashda xatolik sodir bo'ldi!",
            type: "warning",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleFileChange(file, fileList) {
      this.file = fileList;
    },

    uploadFile(options) {
      const { file } = options;

      const formData = new FormData();
      formData.append("file", file);

      this.loading = true;
      this.$http
        .post(`api/v1/my-school/initiative-templates/excel`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          ElMessage.success("Fayl muvaffaqqiyatli yuklandi!");
          this.getSchoolTemplates();
          this.file = [];
        })
        .catch((error) => {
          ElNotification.error({
            message:
              error.response?.data?.message ||
              "Amaliyotni bajarishda xatolik sodir bo'ldi. Iltimos, qayta urinib ko'ring!",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {
    // URL'dan board qiymatini olish
    if (this.$route.query.board) {
      this.board = parseInt(this.$route.query.board);
    }
    this.getSchoolTemplates();
    this.getBoardList();
  },
};
</script>

<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <div class="filters">
        <el-button type="primary" @click="downloadFile">
          <img src="@/assets/images/icons/download.svg" alt="" style="margin-right: 5px" />
          Faylni yuklab oling
        </el-button>
        <el-upload ref="uploadRef" :auto-upload="true" :on-change="handleFileChange" :before-upload="beforeUploadFile"
          :http-request="uploadFile"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
          :show-file-list="false">
          <el-button type="success"> Excel orqali kiritish </el-button>
        </el-upload>
        <el-select v-model="board" placeholder="Doskani tanlang" style="width: 300px" clearable>
          <el-option v-for="board in boards" :key="board.id" :value="board.id" :label="board.title +
            ' ' +
            board.season +
            '-' +
            'mavsum ' +
            board.year +
            ' yil'
            " />
        </el-select>
      </div>
      <div style="display: flex; gap: 5px">
        <router-link to="school-template/add" class="el-button el-button--primary">
          Qo'shish
        </router-link>
      </div>
    </div>
    <el-table :data="dataList" class="table" border height="calc(100vh - 235px)">
      <el-table-column type="index" :index="indexMethod" width="80" label="#" />
      <el-table-column prop="icon" label="Rasmi" min-width="120" align="center">
        <template v-slot="scope">
          <el-image v-if="scope.row.photo" fit="contain" style="height: 80px; width: 80px"
            :src="baseUrl + scope.row.photo" />
        </template>
      </el-table-column>
      <el-table-column prop="title" label="Nomi" min-width="280" />
      <el-table-column prop="board" label="Doska nomi" min-width="280">
        <template v-slot="scope">
          {{
            scope.row.board +
            " " +
            scope.row.board_season +
            "-" +
            "mavsum " +
            scope.row.board_year +
            " yil"
          }}
        </template>
      </el-table-column>
      <el-table-column prop="category" label="Kategoriyasi" min-width="280" />
      <el-table-column prop="requested_amount" label="So'ralgan qiymat" min-width="180">
        <template v-slot="scope">
          {{ scope.row.requested_amount?.toLocaleString("ru-RU") + " UZS" }}
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="Yaratilgan vaqti" min-width="180">
        <template v-slot="scope">
          {{ $moment(scope.row.created_at).format("DD/MM/YYYY") }}
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Izoh" min-width="140">
        <template v-slot="scope">
          <el-popover placement="top-start" title="Izoh" :width="200" trigger="hover" :content="scope.row.description">
            <template #reference>
              <span>{{ scope.row.description.substring(0, 10) + "..." }}</span>
            </template>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="" width="115" align="center">
        <template #default="scope">
          <el-button type="primary" size="small" @click="
            $router.push({
              name: 'SchoolTemplateFormEdit',
              params: { id: scope.row.id },
            })
            ">
            <img height="15" src="@/assets/images/icons/edit.svg" alt="action" />
          </el-button>
          <el-button type="danger" size="small" @click="onClickDelete(scope.row.id)">
            <img height="15" src="@/assets/images/icons/delete.svg" alt="action" />
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="24">
        <div class="pagination-wrapper">
          <span>Jami: {{ totalElements }}</span>
          <el-pagination v-model:current-page="currentPage" class="pagination" @current-change="handleCurrentChange"
            @size-change="handleSizeChange" layout="sizes, prev, pager, next" :total="totalElements"
            v-model:page-size="size" :page-count="totalPages" :background="true"
            :page-sizes="[15, 20, 30, 50, 100, 200, 500, 1000]">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<style scoped lang="scss">
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.filters {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}

.el-button--primary {
  text-decoration: none;
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 12px;
}

.pagination-wrapper>span {
  color: #0a194e;
  font-family: "Montserrat-Bold", sans-serif;
}
</style>